"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../shared/styles");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledText = _styledComponents.default.div.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-2o32jc-0"
})(["display:inline-block;", " color:", ";cursor:inherit;white-space:", ";"], function (_ref) {
  var type = _ref.type,
    variant = _ref.variant;
  return _styles.font[type][variant];
}, function (_ref2) {
  var color = _ref2.color;
  return _styles.colors.text[color];
}, function (_ref3) {
  var noWrap = _ref3.noWrap;
  return noWrap ? 'nowrap' : 'pre-wrap';
});
var Text = function Text(_ref4) {
  var children = _ref4.children,
    type = _ref4.type,
    variant = _ref4.variant,
    color = _ref4.color,
    noWrap = _ref4.noWrap,
    dataCy = _ref4['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
    type: type,
    variant: variant,
    color: color,
    noWrap: noWrap,
    "data-cy": dataCy,
    children: children
  });
};
var _default = exports.default = Text;
Text.defaultProps = {
  type: 'base',
  variant: 'regular',
  color: 'primary'
};